const formObserver = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      const addedNode = mutation.addedNodes[0];
      if (
        addedNode &&
        addedNode.classList &&
        (addedNode.classList.contains("Avada-CookiesMobile") ||
          addedNode.classList.contains("Avada-CookiesFull_bar") ||
          addedNode.classList.contains("Avada-CookiesFloat_card"))
      ) {
        changeCookiesBanner(addedNode);
        return;
      }
    }
  });
});

formObserver.observe(document.body, { childList: true, subtree: true });

function changeCookiesBanner(AvadaElement) {
  const closeButton = AvadaElement.querySelector(".CookiesBar-Pop__Close");
  const cookiesIconElement = AvadaElement.querySelector(
    ".Avada-CookiesBar_Icon"
  );
  const textContainer = AvadaElement.querySelector(".Avada-CookiesBar_Content");
  const textElement = AvadaElement.querySelector(
    ".Avada-CookiesBar__MessageInner"
  );
  const footerButton = AvadaElement.querySelector(".Avada-CookiesBar_Footer");
  textElement.classList.add("cookies-banner-text");
  footerButton.classList.add("cookies-banner-footer-container");
  textContainer.classList.add("cookies-banner-text-container");
  cookiesIconElement.remove();
  closeButton.remove();
}
